// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__vOJNC","error":"InputSecondary_error__76gTe","disabled":"InputSecondary_disabled__35Mdb"};